/**
 * MasterDistortion - Distortion/Overdrive master
 * Saturation chaude pour le mix final
 */

import * as Tone from 'tone';

export class MasterDistortion {
    constructor() {
        this.distortion = new Tone.Distortion({
            distortion: 0.4,    // Quantité de distortion (0-1)
            oversample: '2x',   // Qualité (none, 2x, 4x)
            wet: 1
        });

        this.input = this.distortion;

        this._amount = 0.4;
        this._mix = 0.3;
        this._isActive = true;

        this._outputGain = new Tone.Gain(this._mix);
        this.distortion.connect(this._outputGain);
        this.output = this._outputGain;
    }

    get amount() { return this._amount; }
    get mix() { return this._mix; }

    setAmount(amount) {
        this._amount = amount;
        this.distortion.distortion = amount;
    }

    setMix(mix) {
        this._mix = mix;
        this._outputGain.gain.value = mix;
    }

    connectTo(destination) {
        this.output.connect(destination);
    }

    /**
     * Active/désactive l'effet (économie CPU)
     * @param {boolean} active - true pour activer, false pour désactiver
     */
    setActive(active) {
        if (active === this._isActive) return;
        this._isActive = active;
        this._outputGain.gain.value = active ? this._mix : 0;
    }

    getParams() {
        return {
            amount: this._amount,
            mix: this._mix
        };
    }

    setParams(params) {
        if (params.amount !== undefined) this.setAmount(params.amount);
        if (params.mix !== undefined) this.setMix(params.mix);
    }

    dispose() {
        this.distortion.dispose();
        this._outputGain.dispose();
    }
}
